import { useToastStore, type ToastItem } from '../store/toast';

const KIND_STYLE: Record<ToastItem['kind'], string> = {
  info: 'bg-gray-800 text-white dark:bg-gray-700',
  success: 'bg-green-600 text-white',
  warn: 'bg-amber-500 text-white',
  error: 'bg-red-600 text-white',
};

const ICON: Record<ToastItem['kind'], string> = {
  info: 'ℹ',
  success: '✓',
  warn: '!',
  error: '✕',
};

export function ToastViewport() {
  const items = useToastStore((s) => s.items);
  const dismiss = useToastStore((s) => s.dismiss);

  return (
    <div
      // safe-top: 让 padding-top 等于 env(safe-area-inset-top), 自动避开灵动岛/刘海
      // iOS 18+ 的 .safe-top 还额外 +4px (避免贴边)
      // pt-2 在非灵动岛设备上 (env=20px) 给一点呼吸空间
      className="pointer-events-none fixed inset-x-0 top-0 z-[100] flex flex-col items-center gap-2 px-3 pt-2 safe-top sm:pt-3"
      role="status"
      aria-live="polite"
    >
      {items.map((t) => (
        <div
          key={t.id}
          className={`pointer-events-auto flex max-w-md items-center gap-3 rounded-lg px-4 py-2.5 text-sm shadow-lg ring-1 ring-black/5 ${KIND_STYLE[t.kind]} animate-[fadeIn_0.2s_ease-out]`}
        >
          <span className="text-base leading-none">{ICON[t.kind]}</span>
          <span className="flex-1">{t.text}</span>
          {t.actionLabel && t.to && (
            <a
              href={t.to}
              onClick={() => dismiss(t.id)}
              className="rounded bg-white/20 px-2 py-0.5 text-xs font-medium hover:bg-white/30"
            >
              {t.actionLabel}
            </a>
          )}
          <button
            onClick={() => dismiss(t.id)}
            className="ml-1 text-white/70 hover:text-white"
            aria-label="关闭"
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
